import styled from 'styled-components';

export const StyledPageHeader = styled.div`
  margin: 0 0 30px;
  line-height: 1.4;
  text-align: center;

  small {
    color: ${props => props.theme.colors.primary};
    text-transform: lowercase;
    display: block;
    margin: 0 0 10px;
    display: none;
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.large};
    font-weight: 600;
    margin: 0;
    line-height: 1.2;

    .number {
      display: inline-flex;
      height: 22px;
      width: 22px;
      background: #f1f1f1;
      align-items: center;
      justify-content: center;
      font-size: ${props => props.theme.fontSizes.small};
      border-radius: 100%;
      position: relative;
      margin: 0 10px 0 0;
      top: -3px;
    }
  }

  p {
    margin: 0;
    line-height: 1.4;
    font-size: ${props => props.theme.fontSizes.small};
  }

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    padding-left: 0;
    padding-right: 0;
  }
`
